import { updateUserInTimeBasedCollection } from './firebaseUtils';

// 퀴즈 결과에 따른 사용자 데이터 업데이트
export const updateQuizResult = async (
  zoneNumber: number,
  isSuccess: boolean,
  nickname: string,
  avatarNumber: string,
  currentCoinCount: number = 0
): Promise<boolean> => {
  try {
    
    const updateData: any = {
      [`zoneClearStatus.zone${zoneNumber}`]: isSuccess ? '성공' : '실패'
    };

    // 정답 시 100코인, 오답 시 50코인 추가
    const coinReward = isSuccess ? 100 : 50;
    updateData.coinCount = currentCoinCount + coinReward;


    // 시간 기반 컬렉션에서 사용자 정보 업데이트
    const updateSuccess = await updateUserInTimeBasedCollection(
      nickname,
      avatarNumber,
      updateData
    );

    if (!updateSuccess) {
      console.error('사용자 정보 업데이트에 실패했습니다.');
      return false;
    }

    return true;
  } catch (error) {
    console.error('퀴즈 결과 업데이트 중 오류 발생:', error);
    return false;
  }
};

// 로컬 스토리지의 사용자 정보 업데이트
export const updateLocalUserData = (
  zoneNumber: number,
  isSuccess: boolean,
  currentCoinCount: number = 0
): any => {
  try {
    const currentUser = localStorage.getItem('currentUser');
    if (!currentUser) {
      console.error('로컬스토리지에서 사용자 정보를 찾을 수 없습니다.');
      return null;
    }

    const userData = JSON.parse(currentUser);
    
    // 이미 퀴즈를 풀었는지 확인
    const currentZoneStatus = userData.zoneClearStatus?.[`zone${zoneNumber}`] || '아직안품';
    if (currentZoneStatus !== '아직안품') {
      return userData; // 이미 풀었으면 기존 데이터 반환
    }

    // 코인 계산
    const coinReward = isSuccess ? 100 : 50;
    const newCoinCount = currentCoinCount + coinReward;

    // 업데이트된 사용자 데이터
    const updatedUserData = {
      ...userData,
      coinCount: newCoinCount,
      zoneClearStatus: {
        ...(userData.zoneClearStatus || {
          zone1: '아직안품',
          zone2: '아직안품',
          zone3: '아직안품',
          zone4: '아직안품',
          zone5: '아직안품',
          zone6: '아직안품'
        }),
        [`zone${zoneNumber}`]: isSuccess ? '성공' : '실패'
      }
    };

    // 로컬 스토리지에 저장
    localStorage.setItem('currentUser', JSON.stringify(updatedUserData));
    
    return updatedUserData;
  } catch (error) {
    console.error('로컬 사용자 데이터 업데이트 중 오류 발생:', error);
    return null;
  }
};

// 퀴즈 완료 처리 (Firebase + 로컬 스토리지)
export const completeQuiz = async (
  zoneNumber: number,
  isSuccess: boolean,
  nickname: string,
  avatarNumber: string,
  currentCoinCount: number = 0
): Promise<{ success: boolean; updatedUserData?: any }> => {
  try {
    // Firebase 업데이트
    const firebaseUpdateSuccess = await updateQuizResult(
      zoneNumber,
      isSuccess,
      nickname,
      avatarNumber,
      currentCoinCount
    );

    if (!firebaseUpdateSuccess) {
      return { success: false };
    }

    // 로컬 스토리지 업데이트
    const updatedUserData = updateLocalUserData(zoneNumber, isSuccess, currentCoinCount);
    
    if (!updatedUserData) {
      return { success: false };
    }

    return { success: true, updatedUserData };
  } catch (error) {
    console.error('퀴즈 완료 처리 중 오류 발생:', error);
    return { success: false };
  }
};
